import {SimplePresentation} from "./SimplePresentationRunner";
import {Decadence} from "../../Decadence";
import {DecadenceWinConfig} from "../../config/DecadenceWinConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DecadenceWinFlow} from "../DecadenceWinFlow";
import {DecadenceSound} from "../../sound/DecadenceSound";


export class DecadenceBigWinFlow extends SimplePresentation {


    constructor() {
        super("BigWinPresentation", false);
    }

    shouldRun(): boolean {
        return DecadenceWinConfig.bigWinThresholdReached(Decadence.model.spinWinRatio, Decadence.model.numberOfActiveReels) && !Decadence.model.brokeTheBank;
    }

    buildTimeline() {
        const tl = this.tl;
        tl.add(Decadence.reelView.playMonsterBigWin(), "<")

        const levelTints:number[] = [
            0xff1010,
            0xFFA500,
            0xFDDA0D,
            0x00ffe4,
            0x00FF00,
        ];

        tl.add(() => {
            Decadence.soundPlayer.fadeOutMusic(1);
        })

        tl.add(() => {
            Decadence.transitionScreen.darken(0.2)
            Decadence.soundPlayer.playSound("bigwinLevel1");
        });
        tl.add(() => {
            Decadence.transitionScreen.showBigWinIntro();
        });

        tl.add(() => {
            Decadence.soundPlayer.playSound("musicBigwin");
        }, 1.6);

        let skipped:boolean = false;

        tl.add(() => {
            this.controller.setSkipCallback(() => {
                this.tl.seek("bigWinEnd", false);
                skipped = true;
            });
        })

        const bigWinLevels = DecadenceWinConfig.getBigWinLevels(Decadence.model.spinWinRatio);
        bigWinLevels.forEach((level, index) => {
            const isLastLevel = index == bigWinLevels.length-1;
            const isFirstLevel = index == 0;

            if(!isFirstLevel) {
                tl.add(() => {
                    Decadence.soundPlayer.playSound(`bigwinLevel${index+1}`);
                })
                tl.add(Decadence.transitionScreen.startBigWinLevel(level.bigWinLevel));
            }

            const nextLevel = isLastLevel ? level : bigWinLevels[index+1];
            const countFrom = isFirstLevel ? 0 : Decadence.model.data.playedBetValue * level.ratio;
            const countTo = isLastLevel ? Decadence.model.spinWinnings : Decadence.model.data.playedBetValue * Math.min(Decadence.model.spinWinRatio, nextLevel.ratio);

            tl.add(Decadence.winCounter.countUp(countFrom, countTo, level.duration, levelTints[index]), isFirstLevel ? ">" : "<");
            if(isLastLevel) {
                tl.add(() => {
                    this.controller.setSkipCallback();
                    Decadence.soundPlayer.playSound("bigwinEnds");
                    Decadence.soundPlayer.stopSound("musicBigwin");
                } , `<${level.duration}`);
            }
        })

        tl.addLabel("bigWinEnd");
        tl.add(() => {
            if(skipped) {
                Decadence.soundPlayer.playSound("bigwinEnds");
            }

            this.controller.setSkipCallback();
            // Stop all bigWin sounds
            const bigWinSounds = ["bigwinLevel1", "bigwinLevel2", "bigwinLevel3", "bigwinLevel4", "bigwinLevel5"];
            bigWinSounds.forEach(sound => Decadence.soundPlayer.stopSound(sound));

        })

        tl.add(() => {}, ">0.6");
        tl.add(() => {
            Decadence.soundPlayer.fadeInMusic();
        })
        tl.add(Decadence.transitionScreen.hide());
        tl.add(Decadence.winCounter.hide(), "<");

        // Update keypad
        tl.add(() => {
            const isTotalWin = Decadence.model.mode != GameMode.NORMAL || Decadence.model.nextMode != GameMode.NORMAL;
            Decadence.keypadPlugin.setWin(Decadence.model.accumulatedWin, isTotalWin, Decadence.model.winBelowStake);
        })
    }
}